import PaysTvaController from './pays.tva.controller';
import template from './pays.tva.html';

export default {
	bindings: {
		pays: '='
	},
	template: template,
	controller: PaysTvaController
};
